module.exports = __webpack_public_path__ + "media/images/cz2500-938cc1f592d8f194c6caf5d9b37cd833.svg";